import React from 'react';

import { sendReady } from '~src/bootstrap/ready';
import { useIpc } from '~src/main/utils/ipc-utils';

import { CountrySelect } from '~src/main/country/country-select';
import { CategoryManager } from '~src/main/category/category-manager';
import { Footer } from '~src/main/widget/footer';
import { UpdateLoader } from '~src/main/loader/update-loader';
import { WidgetLayout } from '~src/main/widget/widget-layout';

export const Widget: React.FC = () => {
  const ipc = useIpc();

  React.useEffect(() => {
    sendReady(ipc);
  }, []);

  return (
    <WidgetLayout>
      <UpdateLoader />
      <CountrySelect />
      <CategoryManager />
      <Footer />
    </WidgetLayout>
  );
};
